export default __webpack_public_path__ + "static/fieldmargin-logo-c5a1b8918223c875417b8756145579ec.svg";